import React,{useState} from "react";
import { NavLink } from "react-router-dom";
import { IoMdMenu } from 'react-icons/io';
import { IoMdClose } from 'react-icons/io';

const ProgramNav = ({id}) => {
  const [togle, setTogle] = useState(false);

   const menus = [
    { id: 1, menu: "About" , link: "about"},
    { id: 2, menu: "Dean Massage", link: 'dean-message'},
    { id: 3, menu: "Courses" , link: "courses"},
    { id: 4, menu: "Committee Structure", link: "committee"},
  ]
  
  const showToggle =()=>{
    setTogle(!togle);
    // setSubTogle(!subTogle);
  }

  return (
    <>
    <div className="flex flex-row xs:flex-col sm:flex-col  justify-center w-full my-5 space-x-3 sm:hidden xs:hidden" >
        {
          menus.map( m => (
              <NavLink
                key={m.id} to={`/academics/foundation/${m.link}`}
                className={({ isActive }) =>
                isActive ? "xl:rounded-lg md:rounded-lg font-sans w-fit font-semibold text-base sm:w-full xs:w-full  px-10 bg-[#0863AA] text-white    py-3" : "xl:rounded-lg md:rounded-lg font-serif w-fit sm:w-full xs:w-full font-semibold text-base  text-[#0863AA] border-2    py-3 px-10  hover:bg-[#0863AA] hover:text-white border-[#0863AA] "}>
                    {m.menu}
              </NavLink>
          ))
        }
      </div>
       <div className="flex flex-col  justify-center w-full my-5 xl:hidden md:hidden p-2  " >
        <div className='flex items-end w-full mb-2 cursor-pointer flex-col md:flex-row xl:flex-row justify-start '  onClick={showToggle}>
          {togle ? <IoMdClose className='h-8 w-8'/> : <IoMdMenu className='h-8 w-8'/>}
          
        </div>
        <div className={`flex flex-col border-2 border-[#0863AA] ${togle ? "" : "hidden"}`}>

      
       {
         menus.map( m => (
             <NavLink
               key={m.id} to={`/academics/foundation/${m.link}`}
               className={({ isActive }) =>
               isActive ? "xl:rounded-lg md:rounded-lg font-sans w-fit font-semibold text-base sm:w-full xs:w-full  px-10 bg-[#0863AA] text-white    py-3" : "xl:rounded-lg md:rounded-lg font-serif w-fit sm:w-full xs:w-full font-semibold text-base  text-[#0863AA] border-[1px]    py-3 px-10  hover:bg-[#0863AA] hover:text-white border-[#dddede] "}>
                   {m.menu}
             </NavLink>
         ))
       }
         </div>
     </div>
     </>
  );
};

export default ProgramNav;